import React, { useState } from "react";
import { Eye, EyeOff } from "react-feather";
import axios from "axios";
import { baseurl } from "../../Baseurl";  // Ensure you have the correct baseurl
import { useNavigate } from "react-router-dom"; 


const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);
const [isLoading, setIsLoading] = useState(false); // loader state
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true); // start loader

    console.log("Admin Login Details:", { email, password });

    try {
      const response = await axios.post(`${baseurl}admin_login`, {
        email,
        password,
      });

      console.log("API Response:", response.data);

      if (response.data.message === "Login successful.") {
        const { id, email, first_name } = response.data.data;
        localStorage.setItem("admin_id", id);
        localStorage.setItem("admin_email", email);
        localStorage.setItem("admin_name", first_name);

        navigate("/admin/dashboard");
      }
    } catch (error) {
      console.error("Login Error:", error);
      alert("Login failed. Please try again.");
    } finally {
      setIsLoading(false); // stop loader
    }
  };

  return (
    <div className="bg11">
      <div className="container d-flex justify-content-center align-items-center vh-100">
        <div
          className="card p-4 shadow"
          style={{ maxWidth: "400px", width: "100%" }}
        >
          <h3 className="text-center mb-4">Admin Login</h3>
          <form onSubmit={handleSubmit}>
            <div className="mb-3 text-start">
              <label htmlFor="email" className="form-label">
                Email Address
              </label>
              <input
                type="email"
                id="email"
                className="form-control"
                placeholder="Enter Your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="mb-3 text-start">
              <label htmlFor="password" className="form-label">
                Password <span className="text-danger">*</span>
              </label>
              <div className="input-group">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  className="form-control"
                  placeholder="Enter Your Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <span
                  className="input-group-text"
                  onClick={togglePasswordVisibility}
                  style={{ cursor: "pointer" }}
                >
                  {showPassword ? <EyeOff /> : <Eye />}
                </span>
              </div>
            </div>
            <div className="mt-3">
             <button type="submit" className="btn submitbtnn w-100" disabled={isLoading}>
        {isLoading ? (
          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        ) : (
          "Login"
        )}
      </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
